import {
	FETCH_BILLING_INVOICES_ATTEMPT,
	FETCH_BILLING_INVOICES_SUCCESS,
	FETCH_BILLING_INVOICES_ERROR,
	FETCH_BILLING_INVOICE_ATTEMPT,
	FETCH_BILLING_INVOICE_SUCCESS,
	FETCH_BILLING_INVOICE_ERROR,
	FETCH_BILLING_INVOICE_RESET_STATE,
	CREATE_BILLING_INVOICE_ATTEMPT,
	CREATE_BILLING_INVOICE_SUCCESS,
	CREATE_BILLING_INVOICE_ERROR,
	CREATE_BILLING_INVOICE_RESET_STATE,
	UPDATE_BILLING_INVOICE_ATTEMPT,
	UPDATE_BILLING_INVOICE_SUCCESS,
	UPDATE_BILLING_INVOICE_ERROR,
	UPDATE_BILLING_INVOICE_RESET_STATE,
	UPDATE_BILLING_INVOICE_REFERENCE_ATTEMPT,
	UPDATE_BILLING_INVOICE_REFERENCE_SUCCESS,
	UPDATE_BILLING_INVOICE_REFERENCE_ERROR,
	UPDATE_BILLING_INVOICE_REFERENCE_RESET_STATE,
	SEND_BILLING_INVOICE_ATTEMPT,
	SEND_BILLING_INVOICE_SUCCESS,
	SEND_BILLING_INVOICE_ERROR,
	SEND_BILLING_INVOICE_RESET_STATE,
	CANCEL_BILLING_INVOICE_ATTEMPT,
	CANCEL_BILLING_INVOICE_SUCCESS,
	CANCEL_BILLING_INVOICE_ERROR,
	CANCEL_BILLING_INVOICE_RESET_STATE,
	TOGGLE_BILLING_INVOICE_PAID_ATTEMPT,
	TOGGLE_BILLING_INVOICE_PAID_SUCCESS,
	TOGGLE_BILLING_INVOICE_PAID_ERROR,
	TOGGLE_BILLING_INVOICE_PAID_RESET_STATE,
	GENERATE_ALL_BILLING_INVOICES_ATTEMPT,
	GENERATE_ALL_BILLING_INVOICES_SUCCESS,
	GENERATE_ALL_BILLING_INVOICES_ERROR,
	GENERATE_ALL_BILLING_INVOICES_RESET_STATE,
	FETCH_BILLING_INVOICE_ITEMS_ATTEMPT,
	FETCH_BILLING_INVOICE_ITEMS_SUCCESS,
	FETCH_BILLING_INVOICE_ITEMS_ERROR,
	CREATE_BILLING_INVOICE_ITEM_ATTEMPT,
	CREATE_BILLING_INVOICE_ITEM_SUCCESS,
	CREATE_BILLING_INVOICE_ITEM_ERROR,
	CREATE_BILLING_INVOICE_ITEM_RESET_STATE,
	UPDATE_BILLING_INVOICE_ITEM_ATTEMPT,
	UPDATE_BILLING_INVOICE_ITEM_SUCCESS,
	UPDATE_BILLING_INVOICE_ITEM_ERROR,
	UPDATE_BILLING_INVOICE_ITEM_RESET_STATE,
	DELETE_BILLING_INVOICE_ITEM_ATTEMPT,
	DELETE_BILLING_INVOICE_ITEM_SUCCESS,
	DELETE_BILLING_INVOICE_ITEM_ERROR,
	DELETE_BILLING_INVOICE_ITEM_RESET_STATE,
	FETCH_BILLING_INVOICE_PAYMENTS_ATTEMPT,
	FETCH_BILLING_INVOICE_PAYMENTS_SUCCESS,
	FETCH_BILLING_INVOICE_PAYMENTS_ERROR,
	CREATE_BILLING_INVOICE_PAYMENT_ATTEMPT,
	CREATE_BILLING_INVOICE_PAYMENT_SUCCESS,
	CREATE_BILLING_INVOICE_PAYMENT_ERROR,
	CREATE_BILLING_INVOICE_PAYMENT_RESET_STATE,
	UPDATE_BILLING_INVOICE_PAYMENT_ATTEMPT,
	UPDATE_BILLING_INVOICE_PAYMENT_SUCCESS,
	UPDATE_BILLING_INVOICE_PAYMENT_ERROR,
	UPDATE_BILLING_INVOICE_PAYMENT_RESET_STATE,
	DELETE_BILLING_INVOICE_PAYMENT_ATTEMPT,
	DELETE_BILLING_INVOICE_PAYMENT_SUCCESS,
	DELETE_BILLING_INVOICE_PAYMENT_ERROR,
	DELETE_BILLING_INVOICE_PAYMENT_RESET_STATE,
	BULK_CREATE_BILLING_INVOICES_ATTEMPT,
	BULK_CREATE_BILLING_INVOICES_SUCCESS,
	BULK_CREATE_BILLING_INVOICES_ERROR,
	BULK_CREATE_BILLING_INVOICES_RESET_STATE,
	FETCH_INVOICE_SCHEMA_IDS_ATTEMPT,
	FETCH_INVOICE_SCHEMA_IDS_SUCCESS,
	FETCH_INVOICE_SCHEMA_IDS_ERROR,
	SELECT_INVOICE_SCHEMA,
	SELECT_ALL_INVOICE_SCHEMAS,
} from "../actionTypes/actionTypes";

const initialState = {
	invoices: {
		data: {
			data: [],
			perPage: 20,
			page: 1,
			total: 0,
		},
		attempt: false,
		success: false,
		error: null,
	},
	singleInvoice: {
		data: null,
		attempt: false,
		success: false,
		error: null,
	},
	createInvoice: {
		attempt: false,
		success: false,
		error: null,
		data: null,
	},
	updateInvoice: {
		attempt: false,
		success: false,
		error: null,
		data: null,
	},
	updateReference: {
		attempt: false,
		success: false,
		error: null,
		data: null,
	},
	sendInvoice: {
		attempt: false,
		success: false,
		error: null,
		data: null,
	},
	cancelInvoice: {
		attempt: false,
		success: false,
		error: null,
		data: null,
	},
	togglePaid: {
		attempt: false,
		success: false,
		error: null,
		data: null,
	},
	generateAll: {
		attempt: false,
		success: false,
		error: null,
		data: null,
	},
	items: {
		data: [],
		attempt: false,
		success: false,
		error: null,
	},
	createItem: {
		attempt: false,
		success: false,
		error: null,
		data: null,
	},
	updateItem: {
		attempt: false,
		success: false,
		error: null,
		data: null,
	},
	deleteItem: {
		attempt: false,
		success: false,
		error: null,
	},
	payments: {
		data: {
			payments: [],
			totalPaid: 0,
		},
		attempt: false,
		success: false,
		error: null,
	},
	createPayment: {
		attempt: false,
		success: false,
		error: null,
		data: null,
	},
	updatePayment: {
		attempt: false,
		success: false,
		error: null,
		data: null,
	},
	deletePayment: {
		attempt: false,
		success: false,
		error: null,
	},
	bulkCreate: {
		attempt: false,
		success: false,
		error: null,
		data: null,
	},
	schemaIds: {
		data: {
			schemas: [],
			ids: [],
			total: 0,
		},
		attempt: false,
		success: false,
		error: null,
	},
	selectedSchemas: {
		data: [],
		selectAll: false,
		allSchemaIds: [],
	},
};

const billingInvoicesReducer = (state = initialState, action) => {
	switch (action.type) {
		// Fetch invoices list
		case FETCH_BILLING_INVOICES_ATTEMPT:
			return {
				...state,
				invoices: {
					...state.invoices,
					attempt: true,
					success: false,
					error: null,
				},
			};
		case FETCH_BILLING_INVOICES_SUCCESS:
			return {
				...state,
				invoices: {
					data: action.payload,
					attempt: false,
					success: true,
					error: null,
				},
			};
		case FETCH_BILLING_INVOICES_ERROR:
			return {
				...state,
				invoices: {
					...state.invoices,
					attempt: false,
					success: false,
					error: action.payload,
				},
			};

		// Fetch single invoice
		case FETCH_BILLING_INVOICE_ATTEMPT:
			return {
				...state,
				singleInvoice: {
					...state.singleInvoice,
					attempt: true,
					success: false,
					error: null,
				},
			};
		case FETCH_BILLING_INVOICE_SUCCESS:
			return {
				...state,
				singleInvoice: {
					data: action.payload,
					attempt: false,
					success: true,
					error: null,
				},
			};
		case FETCH_BILLING_INVOICE_ERROR:
			return {
				...state,
				singleInvoice: {
					...state.singleInvoice,
					attempt: false,
					success: false,
					error: action.payload,
				},
			};
		case FETCH_BILLING_INVOICE_RESET_STATE:
			return {
				...state,
				singleInvoice: {
					data: null,
					attempt: false,
					success: false,
					error: null,
				},
			};

		// Create invoice
		case CREATE_BILLING_INVOICE_ATTEMPT:
			return {
				...state,
				createInvoice: {
					attempt: true,
					success: false,
					error: null,
					data: null,
				},
			};
		case CREATE_BILLING_INVOICE_SUCCESS:
			return {
				...state,
				createInvoice: {
					attempt: false,
					success: true,
					error: null,
					data: action.payload,
				},
			};
		case CREATE_BILLING_INVOICE_ERROR:
			return {
				...state,
				createInvoice: {
					attempt: false,
					success: false,
					error: action.payload,
					data: null,
				},
			};
		case CREATE_BILLING_INVOICE_RESET_STATE:
			return {
				...state,
				createInvoice: {
					attempt: false,
					success: false,
					error: null,
					data: null,
				},
			};

		// Update invoice
		case UPDATE_BILLING_INVOICE_ATTEMPT:
			return {
				...state,
				updateInvoice: {
					attempt: true,
					success: false,
					error: null,
					data: null,
				},
			};
		case UPDATE_BILLING_INVOICE_SUCCESS:
			return {
				...state,
				updateInvoice: {
					attempt: false,
					success: true,
					error: null,
					data: action.payload,
				},
				singleInvoice: {
					...state.singleInvoice,
					data: action.payload,
				},
			};
		case UPDATE_BILLING_INVOICE_ERROR:
			return {
				...state,
				updateInvoice: {
					attempt: false,
					success: false,
					error: action.payload,
					data: null,
				},
			};
		case UPDATE_BILLING_INVOICE_RESET_STATE:
			return {
				...state,
				updateInvoice: {
					attempt: false,
					success: false,
					error: null,
					data: null,
				},
			};

		// Update invoice reference
		case UPDATE_BILLING_INVOICE_REFERENCE_ATTEMPT:
			return {
				...state,
				updateReference: {
					attempt: true,
					success: false,
					error: null,
					data: null,
				},
			};
		case UPDATE_BILLING_INVOICE_REFERENCE_SUCCESS:
			return {
				...state,
				updateReference: {
					attempt: false,
					success: true,
					error: null,
					data: action.payload,
				},
				singleInvoice: {
					...state.singleInvoice,
					data: action.payload,
				},
				invoices: {
					...state.invoices,
					data: {
						...state.invoices.data,
						data: state.invoices.data.data.map((invoice) =>
							invoice.id === action.payload.id ? action.payload : invoice
						),
					},
				},
			};
		case UPDATE_BILLING_INVOICE_REFERENCE_ERROR:
			return {
				...state,
				updateReference: {
					attempt: false,
					success: false,
					error: action.payload,
					data: null,
				},
			};
		case UPDATE_BILLING_INVOICE_REFERENCE_RESET_STATE:
			return {
				...state,
				updateReference: {
					attempt: false,
					success: false,
					error: null,
					data: null,
				},
			};

		// Send invoice
		case SEND_BILLING_INVOICE_ATTEMPT:
			return {
				...state,
				sendInvoice: {
					attempt: true,
					success: false,
					error: null,
					data: null,
				},
			};
		case SEND_BILLING_INVOICE_SUCCESS:
			return {
				...state,
				sendInvoice: {
					attempt: false,
					success: true,
					error: null,
					data: action.payload,
				},
				singleInvoice: {
					...state.singleInvoice,
					data: action.payload,
				},
			};
		case SEND_BILLING_INVOICE_ERROR:
			return {
				...state,
				sendInvoice: {
					attempt: false,
					success: false,
					error: action.payload,
					data: null,
				},
			};
		case SEND_BILLING_INVOICE_RESET_STATE:
			return {
				...state,
				sendInvoice: {
					attempt: false,
					success: false,
					error: null,
					data: null,
				},
			};

		// Cancel invoice
		case CANCEL_BILLING_INVOICE_ATTEMPT:
			return {
				...state,
				cancelInvoice: {
					attempt: true,
					success: false,
					error: null,
					data: null,
				},
			};
		case CANCEL_BILLING_INVOICE_SUCCESS:
			return {
				...state,
				cancelInvoice: {
					attempt: false,
					success: true,
					error: null,
					data: action.payload,
				},
				singleInvoice: {
					...state.singleInvoice,
					data: action.payload,
				},
			};
		case CANCEL_BILLING_INVOICE_ERROR:
			return {
				...state,
				cancelInvoice: {
					attempt: false,
					success: false,
					error: action.payload,
					data: null,
				},
			};
		case CANCEL_BILLING_INVOICE_RESET_STATE:
			return {
				...state,
				cancelInvoice: {
					attempt: false,
					success: false,
					error: null,
					data: null,
				},
			};

		// Toggle paid invoice
		case TOGGLE_BILLING_INVOICE_PAID_ATTEMPT:
			return {
				...state,
				togglePaid: {
					attempt: true,
					success: false,
					error: null,
					data: null,
				},
			};
		case TOGGLE_BILLING_INVOICE_PAID_SUCCESS:
			return {
				...state,
				togglePaid: {
					attempt: false,
					success: true,
					error: null,
					data: action.payload,
				},
				singleInvoice: {
					...state.singleInvoice,
					data: action.payload,
				},
			};
		case TOGGLE_BILLING_INVOICE_PAID_ERROR:
			return {
				...state,
				togglePaid: {
					attempt: false,
					success: false,
					error: action.payload,
					data: null,
				},
			};
		case TOGGLE_BILLING_INVOICE_PAID_RESET_STATE:
			return {
				...state,
				togglePaid: {
					attempt: false,
					success: false,
					error: null,
					data: null,
				},
			};

		// Generate all invoices
		case GENERATE_ALL_BILLING_INVOICES_ATTEMPT:
			return {
				...state,
				generateAll: {
					attempt: true,
					success: false,
					error: null,
					data: null,
				},
			};
		case GENERATE_ALL_BILLING_INVOICES_SUCCESS:
			return {
				...state,
				generateAll: {
					attempt: false,
					success: true,
					error: null,
					data: action.payload,
				},
			};
		case GENERATE_ALL_BILLING_INVOICES_ERROR:
			return {
				...state,
				generateAll: {
					attempt: false,
					success: false,
					error: action.payload,
					data: null,
				},
			};
		case GENERATE_ALL_BILLING_INVOICES_RESET_STATE:
			return {
				...state,
				generateAll: {
					attempt: false,
					success: false,
					error: null,
					data: null,
				},
			};

		// Invoice Items
		case FETCH_BILLING_INVOICE_ITEMS_ATTEMPT:
			return {
				...state,
				items: {
					...state.items,
					attempt: true,
					success: false,
					error: null,
				},
			};
		case FETCH_BILLING_INVOICE_ITEMS_SUCCESS:
			return {
				...state,
				items: {
					data: action.payload.items,
					attempt: false,
					success: true,
					error: null,
				},
			};
		case FETCH_BILLING_INVOICE_ITEMS_ERROR:
			return {
				...state,
				items: {
					...state.items,
					attempt: false,
					success: false,
					error: action.payload,
				},
			};

		case CREATE_BILLING_INVOICE_ITEM_ATTEMPT:
			return {
				...state,
				createItem: {
					attempt: true,
					success: false,
					error: null,
					data: null,
				},
			};
		case CREATE_BILLING_INVOICE_ITEM_SUCCESS:
			return {
				...state,
				createItem: {
					attempt: false,
					success: true,
					error: null,
					data: action.payload,
				},
				items: {
					...state.items,
					data: [...state.items.data, action.payload],
				},
			};
		case CREATE_BILLING_INVOICE_ITEM_ERROR:
			return {
				...state,
				createItem: {
					attempt: false,
					success: false,
					error: action.payload,
					data: null,
				},
			};
		case CREATE_BILLING_INVOICE_ITEM_RESET_STATE:
			return {
				...state,
				createItem: {
					attempt: false,
					success: false,
					error: null,
					data: null,
				},
			};

		case UPDATE_BILLING_INVOICE_ITEM_ATTEMPT:
			return {
				...state,
				updateItem: {
					attempt: true,
					success: false,
					error: null,
					data: null,
				},
			};
		case UPDATE_BILLING_INVOICE_ITEM_SUCCESS:
			return {
				...state,
				updateItem: {
					attempt: false,
					success: true,
					error: null,
					data: action.payload,
				},
				items: {
					...state.items,
					data: state.items.data.map(item =>
						item.id === action.payload.id ? action.payload : item
					),
				},
			};
		case UPDATE_BILLING_INVOICE_ITEM_ERROR:
			return {
				...state,
				updateItem: {
					attempt: false,
					success: false,
					error: action.payload,
					data: null,
				},
			};
		case UPDATE_BILLING_INVOICE_ITEM_RESET_STATE:
			return {
				...state,
				updateItem: {
					attempt: false,
					success: false,
					error: null,
					data: null,
				},
			};

		case DELETE_BILLING_INVOICE_ITEM_ATTEMPT:
			return {
				...state,
				deleteItem: {
					attempt: true,
					success: false,
					error: null,
				},
			};
		case DELETE_BILLING_INVOICE_ITEM_SUCCESS:
			return {
				...state,
				deleteItem: {
					attempt: false,
					success: true,
					error: null,
				},
				items: {
					...state.items,
					data: state.items.data.filter(item => item.id !== action.payload.itemId),
				},
			};
		case DELETE_BILLING_INVOICE_ITEM_ERROR:
			return {
				...state,
				deleteItem: {
					attempt: false,
					success: false,
					error: action.payload,
				},
			};
		case DELETE_BILLING_INVOICE_ITEM_RESET_STATE:
			return {
				...state,
				deleteItem: {
					attempt: false,
					success: false,
					error: null,
				},
			};

		// Invoice Payments
		case FETCH_BILLING_INVOICE_PAYMENTS_ATTEMPT:
			return {
				...state,
				payments: {
					...state.payments,
					attempt: true,
					success: false,
					error: null,
				},
			};
		case FETCH_BILLING_INVOICE_PAYMENTS_SUCCESS:
			return {
				...state,
				payments: {
					data: action.payload,
					attempt: false,
					success: true,
					error: null,
				},
			};
		case FETCH_BILLING_INVOICE_PAYMENTS_ERROR:
			return {
				...state,
				payments: {
					...state.payments,
					attempt: false,
					success: false,
					error: action.payload,
				},
			};

		case CREATE_BILLING_INVOICE_PAYMENT_ATTEMPT:
			return {
				...state,
				createPayment: {
					attempt: true,
					success: false,
					error: null,
					data: null,
				},
			};
		case CREATE_BILLING_INVOICE_PAYMENT_SUCCESS:
			return {
				...state,
				createPayment: {
					attempt: false,
					success: true,
					error: null,
					data: action.payload,
				},
				payments: {
					...state.payments,
					data: {
						...state.payments.data,
						payments: [...state.payments.data.payments, action.payload],
						totalPaid: state.payments.data.totalPaid + action.payload.amount,
					},
				},
			};
		case CREATE_BILLING_INVOICE_PAYMENT_ERROR:
			return {
				...state,
				createPayment: {
					attempt: false,
					success: false,
					error: action.payload,
					data: null,
				},
			};
		case CREATE_BILLING_INVOICE_PAYMENT_RESET_STATE:
			return {
				...state,
				createPayment: {
					attempt: false,
					success: false,
					error: null,
					data: null,
				},
			};

		case UPDATE_BILLING_INVOICE_PAYMENT_ATTEMPT:
			return {
				...state,
				updatePayment: {
					attempt: true,
					success: false,
					error: null,
					data: null,
				},
			};
		case UPDATE_BILLING_INVOICE_PAYMENT_SUCCESS:
			const oldPayment = state.payments.data.payments.find(p => p.id === action.payload.id);
			return {
				...state,
				updatePayment: {
					attempt: false,
					success: true,
					error: null,
					data: action.payload,
				},
				payments: {
					...state.payments,
					data: {
						...state.payments.data,
						payments: state.payments.data.payments.map(payment =>
							payment.id === action.payload.id ? action.payload : payment
						),
						totalPaid: state.payments.data.totalPaid - (oldPayment?.amount || 0) + action.payload.amount,
					},
				},
			};
		case UPDATE_BILLING_INVOICE_PAYMENT_ERROR:
			return {
				...state,
				updatePayment: {
					attempt: false,
					success: false,
					error: action.payload,
					data: null,
				},
			};
		case UPDATE_BILLING_INVOICE_PAYMENT_RESET_STATE:
			return {
				...state,
				updatePayment: {
					attempt: false,
					success: false,
					error: null,
					data: null,
				},
			};

		case DELETE_BILLING_INVOICE_PAYMENT_ATTEMPT:
			return {
				...state,
				deletePayment: {
					attempt: true,
					success: false,
					error: null,
				},
			};
		case DELETE_BILLING_INVOICE_PAYMENT_SUCCESS:
			const deletedPayment = state.payments.data.payments.find(p => p.id === action.payload.paymentId);
			return {
				...state,
				deletePayment: {
					attempt: false,
					success: true,
					error: null,
				},
				payments: {
					...state.payments,
					data: {
						...state.payments.data,
						payments: state.payments.data.payments.filter(payment => payment.id !== action.payload.paymentId),
						totalPaid: state.payments.data.totalPaid - (deletedPayment?.amount || 0),
					},
				},
			};
		case DELETE_BILLING_INVOICE_PAYMENT_ERROR:
			return {
				...state,
				deletePayment: {
					attempt: false,
					success: false,
					error: action.payload,
				},
			};
		case DELETE_BILLING_INVOICE_PAYMENT_RESET_STATE:
			return {
				...state,
				deletePayment: {
					attempt: false,
					success: false,
					error: null,
				},
			};

		// Bulk Create Billing Invoices
		case BULK_CREATE_BILLING_INVOICES_ATTEMPT:
			return {
				...state,
				bulkCreate: {
					attempt: true,
					success: false,
					error: null,
					data: null,
				},
			};
		case BULK_CREATE_BILLING_INVOICES_SUCCESS:
			return {
				...state,
				bulkCreate: {
					attempt: false,
					success: true,
					error: null,
					data: action.payload,
				},
			};
		case BULK_CREATE_BILLING_INVOICES_ERROR:
			return {
				...state,
				bulkCreate: {
					attempt: false,
					success: false,
					error: action.payload,
					data: null,
				},
			};
		case BULK_CREATE_BILLING_INVOICES_RESET_STATE:
			return {
				...state,
				bulkCreate: {
					attempt: false,
					success: false,
					error: null,
					data: null,
				},
			};

		// Fetch Invoice Schema IDs
		case FETCH_INVOICE_SCHEMA_IDS_ATTEMPT:
			return {
				...state,
				schemaIds: {
					...state.schemaIds,
					attempt: true,
					success: false,
					error: null,
				},
			};
		case FETCH_INVOICE_SCHEMA_IDS_SUCCESS:
			return {
				...state,
				schemaIds: {
					data: action.payload,
					attempt: false,
					success: true,
					error: null,
				},
			};
		case FETCH_INVOICE_SCHEMA_IDS_ERROR:
			return {
				...state,
				schemaIds: {
					...state.schemaIds,
					attempt: false,
					success: false,
					error: action.payload,
				},
			};

		// Select Invoice Schema
		case SELECT_INVOICE_SCHEMA: {
			const newSelectedSchemas = [...state.selectedSchemas.data];
			const found = newSelectedSchemas.find(
				(e) => e.id === action.payload.data.id
			);
			if (found) {
				newSelectedSchemas.splice(
					newSelectedSchemas.indexOf(found),
					1
				);
			} else {
				newSelectedSchemas.push(action.payload.data);
			}
			return {
				...state,
				selectedSchemas: {
					...state.selectedSchemas,
					data: [...newSelectedSchemas],
					selectAll: false,
				},
			};
		}

		case SELECT_ALL_INVOICE_SCHEMAS: {
			const select = action.payload.data;
			const allSchemaIds = action.payload.allSchemaIds || [];
			// If select all is true and we have IDs from backend, use those
			// Otherwise, select all schemas from the current list
			if (select && allSchemaIds.length > 0) {
				return {
					...state,
					selectedSchemas: {
						data: state.schemaIds.data.schemas.filter(s => allSchemaIds.includes(s.id)),
						selectAll: select,
						allSchemaIds: allSchemaIds,
					},
				};
			}
			return {
				...state,
				selectedSchemas: {
					data: !select ? [] : state.schemaIds.data.schemas.map((schema) => schema),
					selectAll: select,
					allSchemaIds: allSchemaIds,
				},
			};
		}

		default:
			return state;
	}
};

export default billingInvoicesReducer;

